import * as React from 'react';
import * as classnames from 'classnames/bind';
import bind from 'bind-decorator';
import {OnResizeEventFn, ResizeEvent, Resizer} from '@mintdata-wsp/wsp/ui/components/resizable/Resizer';
import {PanelContentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/PanelView';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';

const styles = require('./SplitView.less');
const cx = classnames.bind(styles);

export type OnSplitViewResized = OnResizeEventFn;

export interface SplitViewProps extends PanelContentProps
{
    isVisible:boolean,
    isVertical:boolean;
    firstPercentLength:number;
    // renderFirst:()=>(React.ReactElement<any>);
    // renderSecond:()=>(React.ReactElement<any>);
    className?:string;
    onSplitViewResized?:OnSplitViewResized;
}

@observer
export class SplitView extends React.Component<SplitViewProps, any>
{
    private _ref:HTMLElement = null;
    private _totalLength:number = NaN;

    @observable
    private _firstBasisPercent:number;

    constructor(props: SplitViewProps)
    {
        super(props);
        this._init(props);
    }

    componentWillReceiveProps(props:SplitViewProps):void
    {
        this._init(props);
    }

    @action.bound
    private _init(props:SplitViewProps)
    {
        this._firstBasisPercent = props.firstPercentLength;

        const onPanelResize = props.onPanelResize;
        if( onPanelResize && typeof onPanelResize === 'function')
        {
            onPanelResize((e:ResizeEvent)=>
            {
                this._remeasureLength();
            });
        }
    }

    @action.bound
    private _onResize(e:ResizeEvent):void
    {
        const {isVertical} = this.props;
        const delta = isVertical? e.deltaX:e.deltaY;

        if( isNaN(this._totalLength) )
            return;

        const percentDelta = delta / this._totalLength;
        this._firstBasisPercent += percentDelta;

        this._fireResizeEvent(e);
    }

    @bind
    private _fireResizeEvent(e:ResizeEvent)
    {
        const {onSplitViewResized} = this.props;

        if( onSplitViewResized && typeof onSplitViewResized === 'function' )
            onSplitViewResized(e);
    }

    @action.bound
    private _onRef(ref:HTMLElement)
    {
        if( ref )
        {
            this._ref = ref;
            this._remeasureLength();
        }
    }

    @bind
    private _remeasureLength():void
    {
        if( this._ref )
        {
            const {isVertical} = this.props;
            const bounds = this._ref.getBoundingClientRect();

            this._totalLength = isVertical ? bounds.width : bounds.height;
        }
    }

    @bind
    private _renderFirst()
    {
        return this.props.children[0];
    }

    @bind
    private _renderSecond()
    {
        return this.props.children[1];
    }

    render()
    {
        const {isVisible, isVertical} = this.props;
        const styleFirst:any = {};
        const styleSecond:any = {};

        styleFirst.flexBasis = `${this._firstBasisPercent*100.0}%`;
        styleSecond.flexBasis = `${(1 - this._firstBasisPercent)*100.0}%`;

        return  <div ref={this._onRef} className={cx('baseSplitView',
                                                     {'verticalSplitView':isVertical},
                                                     {'horizontalSplitView':!isVertical},
                                                 )}>

                    <div style={styleFirst}
                         className={cx('splitViewContent')}>
                        {this._renderFirst()}
                    </div>

                    <Resizer isVisible={isVisible} isVertical={isVertical} onResize={this._onResize}/>

                    <div style={styleSecond}
                         className={cx('splitViewContent')}>
                        {this._renderSecond()}
                    </div>

                </div>;
    }
}










